var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-actions',{staticClass:"d-flex justify-end"},[_c('v-btn',{attrs:{"to":_vm.to,"color":"#173042","dark":!_vm.isDisabled,"disabled":_vm.isDisabled},on:{"click":_vm.next}},[_vm._v(_vm._s(_vm.text || "Proceed to Next Step"))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }